import script from "./reply.vue?vue&type=script&setup=true&lang=js"
export * from "./reply.vue?vue&type=script&setup=true&lang=js"

import "./reply.vue?vue&type=style&index=0&id=330e93f4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-330e93f4"]])

export default __exports__